import { Typography } from '@klickly/front-packages';
import styled, { css } from 'styled-components';
import { GRID_DEVICES_MAX } from '../../../../constants';

export const StyledHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 48px;

    @media (${GRID_DEVICES_MAX.sm}) {
        ${({ $simple }) =>
            $simple &&
            css`
                margin-bottom: 24px;
            `};
    }
`;

export const StyledControls = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledSlideCounter = styled(Typography.Text)`
    padding: 8px 24px;
    font-weight: 500;

    @media (${GRID_DEVICES_MAX.sm}) {
        ${({ $simple }) =>
            $simple &&
            css`
                padding-right: 0;
                font-size: 14px;
            `};
    }
`;
